export default {
  tokenP:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwibmFtZSI6IlRlc3QgUHJlbWl1bSIsInVzZXJuYW1lIjoidGVzdEB0ZXN0LmNv' +
    'bSIsImVtYWlsIjoidGVzdEB0ZXN0LmNvbSIsImlhdCI6MTYyNzUxMzEwMywiZXhwIjoxNjkwNTg1MTAzfQ.Rh8g0Qo1tv1JQCCek3OjcbDkxlt' +
    'A-EZDaw6AJDI87Cs',
};
